export default [
    "file-text", "book-open", "settings", "log-out", "pen-line", "shield-check",
    "user-search", "calendar-days", "wallet", "graduation-cap", "bar-chart-3",
    "building", "building-2", "layout-template", "scroll-text", "chevron-down",
    "chevron-left", "chevron-right", "panel-left-open", "panel-left-close", "plus", "x", "check",
    "trash-2", "pencil", "download", "filter", "search", "arrow-left",
    "user-plus", "arrow-right", "ellipsis-vertical", "minus", "circle-help",
    "mail", "link",
    "clock", "check-circle", "circle-x", "clipboard-list", "archive", "pencil-line",
    "circle-dot", "play-circle", "x-circle", "alert-circle", "lock", "circle",
    "minus-circle", "eye", "mouse-pointer-click",
    // The verification hero needs four glyphs that stay tellable apart without colour:
    // check, triangle, cross, question mark.
    "triangle-alert",
];
